export default __webpack_public_path__ + "static/media/a004-example1.d019d160.jpg";